import { computed, ref } from 'vue';
import { acceptHMRUpdate, defineStore, storeToRefs } from 'pinia';
import { useApiResponsesStore } from '../responses';

/**
 * This store contains all form related data
 */
export const useChooserFormStore = defineStore('chooser-form', () => {
    const apiResponsesStore = useApiResponsesStore();
    const { regionResponses } = storeToRefs(apiResponsesStore);

    const debug = ref(false);

    const formData = ref({
        region: {
            name: null,
            code: null,
        },
        occupation: {
            levelOne: null,
            levelTwo: null,
        },
    });

    const regionAndOccupationReady = computed(() => {
        if (!formData.value.occupation.levelTwo) {
            return false;
        } else if (!regionResponses.value.annualLivingWages) {
            return false;
        }
        return true;
    });

    return {
        debug,
        formData,
        regionAndOccupationReady,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(
        acceptHMRUpdate(useChooserFormStore, import.meta.hot)
    );
}
